import gql from "graphql-tag";

export const DEVICE_LOGGER_QUERY = gql`
query DeviceLog($sortBy: [String!]) {
  deviceLogs(sort: $sortBy) {
    data {
      id
      attributes {
        username
        error_message
        device_user_agent
        todays_log
        device_model
        event_time
        build_number
        version
        screen_resolution
        past_classes
      }
    }
  }
}
`;

export const PAYMENTS_QUERY = gql`
query Payments($sortBy: [String!], $pagination: PaginationArg) {
  payments(sort: $sortBy, pagination: $pagination) {
    data {
      id
      attributes {
        whents
        user {
          data {
            attributes {
              username
            }
          }
        }
        service_points
        amount
        currency
        description
        state
        source_token
      }
    }
  }
}
`;

export const LABELS_QUERY = gql`
query Labels($sortBy: [String!]) {
  categories(sort: ["id:asc"]) {
    data {
      id
      attributes {
        code
        title
        subcategories {
          data {
            id
            attributes {
              code
              title
              skills {
                data {
                  id
                  attributes {
                    code
                    title
                    subskills {
                      data {
                        id
                        attributes {
                          code
                          title
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  labels(sort: $sortBy) {
    data {
      id
      attributes {
        title
        accepted_categorization
        categories {
          data {
            id
            attributes {
              code
              title
            }
          }
        }
        subcategories {
          data {
            id
            attributes {
              code
              title
            }
          }
        }
        skills {
          data {
            id
            attributes {
              code
              title
            }
          }
        }
        subskills {
          data {
            id
            attributes {
              code
              title
            }
          }
        }
      }
    }
  }
}
`;

export const UPDATE_LABEL = gql`
mutation UpdateLabel($id: ID!, $title: String!, $accepted_categorization: Boolean!, $categories: [ID]!) {
  updateLabel(id: $id, data: {title: $title, accepted_categorization: $accepted_categorization, categories: $categories}) {
    data {
      id
      attributes {
        title
        accepted_categorization
      }
    }
  }
}
`;

export const DELETE_LABEL = gql`
mutation DeleteLabel($id: ID!) {
  deleteLabel(id: $id) {
    data {
      id
      attributes {
        title
        accepted_categorization
      }
    }
  }
}`;

export const CREATE_LABEL = gql` 
mutation CreateLabel($title: String!) {
  createLabel(data: {title: $title}) {
    data {
      id
      attributes {
        title
        accepted_categorization
      }
    }
  }
}`;

export const USERS_QUERY = gql`
query Users($sortBy: [String!], $filters: UsersPermissionsUserFiltersInput) {
  usersPermissionsUsers(sort: $sortBy, filters: $filters) {
    data {
      id
      attributes {
        username
        email
        worker
        user_points
        deleted_since
        delete_reason
        address {
          data {
            id
            attributes {
              country {
                data {
                  attributes {
                    name
                    alpha_code
                  }
                }
              }
              city
              state
              street
            }
          }
        }
        fullname
        blocked
        confirmed
        advertisement_log {
          data {
            attributes {
              
          updatedAt
          interstitial_load_amount
          interstitial_click_amount
          banner_load_amount
          banner_click_amount
            }
          }
        }
      }
    }
  }
}
`;

export const UPDATE_USER_QUERY = gql`
mutation updateUsersPermissionsUser($id: ID!, $user_points: Int) {
  updateUsersPermissionsUser(id: $id, data: {user_points: $user_points}) {
    data {
      id
    }
  }
}`;

export const POINTS_UPLOAD_OPTION_QUERY = gql`
query {
  pointsUploadOptions(sort: ["id:asc"]) {
    data {
      id
      attributes {
        point_value
        price
        currency
      }
    }
  }
}
`;

export const UPDATE_POINTS_UPLOAD_OPTION = gql`
mutation UpdatePointsUploadOption($id: ID!, $point_value: Int, $price: Int, $currency: ENUM_POINTSUPLOADOPTION_CURRENCY) {
  updatePointsUploadOption(id: $id, data: {point_value: $point_value, price: $price, currency: $currency}) {
    data {
      id
      attributes {
        point_value
        price
        currency
      }
    }
  }
}
`;

export const DELETE_POINTS_UPLOAD_OPTION = gql`
mutation DeletePointsUploadOption($id: ID!) {
  deletePointsUploadOption(id: $id) {
    data {
      id
      attributes {
        point_value
        price
        currency
      }
    }
  }
}`;

export const CREATE_POINTS_UPLOAD_OPTION = gql` 
mutation CreatePointsUploadOption($point_value: Int, $price: Int, $currency: ENUM_POINTSUPLOADOPTION_CURRENCY) {
  createPointsUploadOption(data: {point_value: $point_value, price: $price, currency: $currency}) {
    data {
      id
      attributes {
        point_value
        price
        currency
      }
    }
  }
}`;

export const POINTS_OF_ACTION_CASE_QUERY = gql`
query {
  pointsOfActionCases(sort: ["id:asc"]) {
    data {
      id
      attributes {
        action_case
        points_value
      }
    }
  }
}
`;

export const UPDATE_POINTS_OF_ACTION_CASE = gql`
mutation updatePointsOfActionCase($id: ID!, $points_value: Int) {
  updatePointsOfActionCase(id: $id, data: {points_value: $points_value}) {
    data {
      id
      attributes {
        createdAt
        updatedAt
        action_case
        points_value
      }
    }
  }
}
`;

export const LOGIN_MUTATION = gql`
mutation LoginMutation($email: String!, $password: String!) {
  login(input: {
    identifier: $email
    password: $password
  }) {
    jwt
  }
}
`;


export const TICKETS_QUERY = gql`
query Tickets($sortBy: [String!]) {
  tickets(sort: $sortBy) {
    data {
      id
      attributes {
        createdAt
        updatedAt
        type
        message
        hidden_field
        creator {
          data {
            id
            attributes {
              username
              email
            }
          }
        }
        state
      }
    }
  }
}
`;

export const UPDATE_TICKET_QUERY = gql`
mutation UpdateTicket($id: ID!, $state: ENUM_TICKET_STATE) {
  updateTicket(id: $id, data: {state: $state}) {
    data {
      id
      attributes {
        createdAt
        updatedAt
        type
        message
        hidden_field
        state
        creator {
          data {
            id
            attributes {
              username
            }
          }
        }
      }
    }
  }
}`;

export const TRANSLATIONS_QUERY = gql`
query SavedTranslations($sortBy: [String!], $filters: SavedTranslationFiltersInput) {
  savedTranslations(sort: $sortBy, filters: $filters) {
    data {
      id
      attributes {
        createdAt
        updatedAt
        identification
        translation
        language
      }
    }
  }
}`;

export const UPDATE_TRANSLATIONS_QUERY = gql`
mutation UpdateSavedTranslation($id: ID!, $translation: String) {
  updateSavedTranslation(id: $id, data: {translation: $translation}) {
    data {
      id
      attributes {
        identification
        translation
        language
        createdAt
        updatedAt
      }
    }
  }
}`;

export const DELETE_TRANSLATIONS_QUERY = gql`
mutation DeleteSavedTranslation($id: ID!) {
  deleteSavedTranslation(id: $id) {
    data {
      id
      attributes {
        identification
        translation
        language
        createdAt
        updatedAt
      }
    }
  }
}`;

export const MOBILE_TEMPLATE_QUERY = gql`
query mobileTemplates($sortBy: [String!], $filters: MobileTemplateFiltersInput) {
  mobileTemplates(sort: $sortBy, filters: $filters) {
    data {
      id
      attributes {
        content
        template_type
        title
        market_type
        createdAt
        updatedAt
      }
    }
  }
}`;

export const UPDATE_MOBILE_TEMPLATE_QUERY = gql`
mutation UpdateMobileTemplate($id: ID!, $content: String, $title: String) {
  updateMobileTemplate(id: $id, data: {content: $content, title: $title}) {
    data {
      id
      attributes {
        content
        template_type
        title
        market_type
        createdAt
        updatedAt
      }
    }
  }
}`;

export const MAIL_TEMPLATE_QUERY = gql`
query mailTemplates($sortBy: [String!], $filters: MailTemplateFiltersInput) {
  mailTemplates(sort: $sortBy, filters: $filters) {
    data {
      id
      attributes {
        body
        template_type
        subject
        market_type
        createdAt
        updatedAt
      }
    }
  }
}`;

export const UPDATE_MAIL_TEMPLATE_QUERY = gql`
mutation UpdateMailTemplate($id: ID!, $body: String, $subject: String) {
  updateMailTemplate(id: $id, data: {body: $body, subject: $subject}) {
    data {
      id
      attributes {
        body
        template_type
        subject
        market_type
        createdAt
        updatedAt
      }
    }
  }
}`;

export const ENTRY_SUGGESTION_QUERY = gql`
query EntrySuggestions($sortBy: [String!], $filters: EntrySuggestionFiltersInput) {
  entrySuggestions(sort: $sortBy, filters: $filters) {
    data {
      id
      attributes {
        creator {
          data {
            id
            attributes {
              createdAt
              updatedAt
              username
              email
              confirmed
              blocked
              fullname
              phonenumber1
              worker
              Iam
              phonenumber2
              language
              deleted_since
            }
          }
        }
        vehicle_brand {
          data {
            id
            attributes {
              name
            }
          }
        }
        created_for
        suggested_entry
        language_code
        approved
        createdAt
        updatedAt
      }
    }
  }
}`;

export const UPDATE_ENTRY_SUGGESTION = gql`
mutation UpdateEntrySuggestion($id: ID!, $approved: Boolean, $suggested_entry: String) {
  updateEntrySuggestion(id: $id, data: {approved: $approved, suggested_entry: $suggested_entry}) {
    data {
      id
      attributes {
        creator {
          data {
            id
            attributes {
              createdAt
              updatedAt
              username
              email
              confirmed
              blocked
              fullname
              phonenumber1
              worker
              Iam
              phonenumber2
              language
              deleted_since
            }
          }
        }
        vehicle_brand {
          data {
            id
            attributes {
              name
            }
          }
        }
        created_for
        suggested_entry
        language_code
        approved
        createdAt
        updatedAt
      }
    }
  }
}
`;

export const DELETE_ENTRY_SUGGESTION = gql`
mutation DeleteEntrySuggestion($id: ID!) {
  deleteEntrySuggestion(id: $id) {
    data {
      id
      attributes {
        creator {
          data {
            id
            attributes {
              createdAt
              updatedAt
              username
              email
              confirmed
              blocked
              fullname
              phonenumber1
              worker
              Iam
              phonenumber2
              language
              deleted_since
            }
          }
        }
        vehicle_brand {
          data {
            id
            attributes {
              name
            }
          }
        }
        created_for
        suggested_entry
        language_code
        approved
        createdAt
        updatedAt
      }
    }
  }
}`;


export const publicOperations = [
]